import React from 'react';
import { Trash2, Loader2 } from 'lucide-react';

const DeleteEmailAccountModal = ({
  isOpen,
  onClose,
  emailAccount,
  onConfirm,
  isDeleting
}) => {
  if (!isOpen || !emailAccount) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-gray-900 border border-gray-700 rounded-2xl p-6 max-w-md mx-4">
        <h3 className="text-xl font-bold text-white mb-2">Remove Email Account?</h3>
        <p className="text-gray-400 mb-4">
          Are you sure you want to remove <strong className="text-white">{emailAccount.name || emailAccount.email}</strong>?
          {emailAccount.type === 'nylas' && (
            <span className="block mt-2 text-sm">This will disconnect the account from Nylas.</span>
          )}
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors"
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            {isDeleting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Removing...
              </>
            ) : (
              <>
                <Trash2 size={16} />
                Remove
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEmailAccountModal;
